/* La lista desplegable propia. La caja (borde, foco, error) la comparte con
   Input en Control.module.css; acá va lo que un <select> no tiene: el botón
   que muestra el valor y el listbox flotante. */
.raiz {
  position: relative;
  display: block;
  min-width: 0;
}

.boton {
  display: flex;
  align-items: center;
  text-align: left;
  cursor: pointer;
}
.boton:disabled {
  cursor: not-allowed;
}
.valor {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.placeholder {
  color: var(--text-subtle);
}

.lista {
  position: fixed;
  z-index: var(--z-popover);
  box-sizing: border-box;
  margin: 0;
  padding: var(--s-3);
  list-style: none;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: var(--surface-card);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-panel);
  box-shadow: var(--sh-md);
  outline: none;
  transform-origin: top center;
  animation: entrar var(--dur-fast) var(--ease-standard);
}
.lista[data-arriba] {
  transform-origin: bottom center;
}
.lista:focus-visible {
  outline: none;
  box-shadow: var(--sh-md);
}

.opcion {
  display: flex;
  align-items: center;
  gap: var(--s-4);
  min-height: calc(var(--h-control-md) - var(--s-2));
  padding: 0 var(--s-5);
  border-radius: var(--r-md);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-strong);
  cursor: pointer;
  user-select: none;
}
.opcion[data-activo] {
  background: var(--surface-brand-faint);
}
.opcion[aria-disabled] {
  color: var(--control-disabled-text);
  cursor: not-allowed;
}
.opcionTexto {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  padding-block: var(--s-2);
}
.opcionDescripcion {
  font-size: var(--fs-3xs);
  color: var(--text-subtle);
}
.opcionDetalle {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-3xs);
  color: var(--text-subtle);
}
.tilde {
  display: inline-flex;
  color: var(--text-brand);
}

@keyframes entrar {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(-2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.lista[data-arriba] {
  animation-name: entrarArriba;
}
@keyframes entrarArriba {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lista {
    animation: none;
  }
}
